import React from 'react'

export default function PlaceHolderContent({img,heading,content}) {
  return (
    <div className="details-wrap mb-4">
    <h5 className="px-4">{heading}
    </h5>
    <hr />
    <div className="placeholder py-5 text-center mx-auto"  style={{
            maxWidth: "350px",
          }}>
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={img}
          alt="KYC placeholder"
          className="img-fluid"
         
        />
      </div>

      <div className="placeholderContent">
        {" "}
        <h6 className="fw-600 fs20 text-dark">
        </h6>
        <p
          className="text-muted text-center mb-0"
          style={{ fontSize: "14px" }}
        >
         {content}
        </p>
      </div>
    </div>
  </div>
  )
}
